import React from "react";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";

function normalizeMediaSrc(src = "") {
    if (typeof src !== "string") return "";
    const trimmed = src.trim();
    if (!trimmed) return "";

    // Blob URLs and data URIs are local — return as-is without OVH normalization
    if (trimmed.startsWith("blob:") || trimmed.startsWith("data:")) return trimmed;

    try {
        const url = new URL(trimmed);
        const host = url.host.toLowerCase();
        const isOvhS3Host = host.endsWith("io.cloud.ovh.net");
        if (!isOvhS3Host) return trimmed;

        // Virtual-hosted style: BUCKET.s3.region.io.cloud.ovh.net/KEY — already correct
        if (!host.startsWith("s3.")) return trimmed;

        // Path style: s3.region.io.cloud.ovh.net/BUCKET/KEY — convert to virtual-hosted
        const parts = url.pathname.split("/").filter(Boolean);
        if (parts.length < 2) return trimmed;

        const bucket = parts[0];
        const key = parts.slice(1).join("/");
        return `${url.protocol}//${bucket}.${url.host}/${key}`;
    } catch {
        return trimmed;
    }
}

function isVideoSource(src = "") {
    if (typeof src !== "string") return false;
    const normalized = src.trim().toLowerCase();
    if (!normalized) return false;

    if (normalized.startsWith("data:video/")) return true;
    if (normalized.includes(".m3u8")) return true;
    return /(\.mp4|\.webm|\.ogg|\.mov)(\?|#|$)/i.test(normalized);
}

export default function MediaContent({ src, pointerEvents = "auto" }) {
    const normalizedSrc = normalizeMediaSrc(src);

    if (!normalizedSrc) {
        return (
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#eceff1",
                    border: "1px dashed #b0bec5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    pointerEvents,
                }}
            >
                <ImageOutlinedIcon sx={{ color: "#90a4ae", fontSize: 44 }} />
            </div>
        );
    }

    if (isVideoSource(normalizedSrc)) {
        return (
            <video
                src={normalizedSrc}
                muted
                loop
                playsInline
                autoPlay
                preload="metadata"
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                    pointerEvents,
                }}
            />
        );
    }

    return (
        <img
            src={normalizedSrc}
            alt=""
            style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
                pointerEvents,
            }}
        />
    );
}
